/**
 * FIRST OPEN, piece 3: the last known home shell (packet J12).
 *
 * What HubContent shows while the two boot checks run, when this device has
 * a remembered home. Instead of a full-page spinner on an empty screen, the
 * frame of the home that is coming is already there, with the person's first
 * name and the spinner INSIDE it. The real home replaces this the moment the
 * checks answer, matching or not.
 *
 * Everything on screen here is either the remembered kind, the remembered
 * first name, or a grey block. NOTHING else stored is rendered, and no
 * sentence here says anything about the studio: the loading label is the one
 * that home's own Suspense fallback already uses (lib/lastHomeShell.ts).
 *
 * The grey blocks are decoration standing in for cards that have not loaded,
 * so they are aria-hidden; StudioLoading carries the one role="status" a
 * screen reader should hear, exactly as the plain spinner did before.
 */
import StudioLoading from './StudioLoading';
import { HOME_SHELL_LABEL, type HomeShell } from '../lib/lastHomeShell';

const frameStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: 'var(--space-4)',
  width: '100%',
  maxWidth: 480,
  margin: '0 auto',
  padding: 'var(--space-5) var(--space-4) 96px',
  textAlign: 'left',
};

const nameStyle: React.CSSProperties = {
  margin: 0,
  fontSize: 30,
  lineHeight: 1.1,
  fontWeight: 900,
  color: 'var(--ink)',
  overflowWrap: 'anywhere',
};

function Block({ height }: { height: number }) {
  return (
    <div
      aria-hidden="true"
      style={{
        height,
        width: '100%',
        borderRadius: 'var(--radius-lg)',
        background: 'var(--paper)',
        border: '1px solid var(--line)',
        opacity: 0.6,
      }}
    />
  );
}

export default function LastHomeShell({ shell }: { shell: HomeShell }) {
  return (
    <div style={frameStyle} data-home-shell={shell.kind}>
      {shell.firstName ? <h1 style={nameStyle}>{shell.firstName}</h1> : <Block height={38} />}
      <StudioLoading fullPage label={HOME_SHELL_LABEL[shell.kind]} />
      <Block height={112} />
      <Block height={72} />
      <Block height={72} />
    </div>
  );
}
